import React, { useContext } from 'react';
import NavWorker from './NavWorker';
import { withRouter } from 'react-router-dom';

import { UserContext } from '../../context/UserProvider';
import BlueButton from '../BlueButton';

import { Label } from 'reactstrap';
import InputForm from '../InputForm';

const WorkerProfile = (props) => {

    const { user } = useContext(UserContext);

    return (
        <div>
            <NavWorker />
            <div className='container'>
                <div className='mt-3' onClick={() => props.history.push('/dashboard')}>
                    <span class="material-icons">
                        keyboard_backspace
                    </span>
                </div>
                <div className='mt-2 mb-4'>
                    <h5>Configuración</h5>
                </div>
                <div className='mt-3'>
                    <Label>Email</Label>
                    <InputForm placeholder={user.email} disabled />
                </div>
                <div className='mt-3'>
                    <Label>Nombre</Label>
                    <InputForm placeholder={user.name} disabled />
                </div>
                <div className='mt-3'>
                    <Label>Descripción</Label>
                    <InputForm placeholder={'Siempre a tu servicio'} disabled />
                    <Label className='mt-2'></Label>
                </div>
                <div className='mt-3'>
                    <Label>Medio de traslado</Label>
                    <InputForm placeholder={'Bicicleta'} disabled />
                    <Label className='mt-2'></Label>
                </div>
            </div>
            <div className='mt-4'>
                <BlueButton label={'Guardar'} />
            </div>
        </div>
    );
};

export default withRouter(WorkerProfile);
